import { FaArrowRightLong } from 'react-icons/fa6';
import { Link } from 'react-router-dom';

const Catalogue = () => {
  return (
    <div className="content flex flex-col gap-[15px] sm:gap-[24px] pb-[50px] 1400:px-0 px-[16px] pt-10 md:pt-5">
      <h2 className="font-clash text-[40px] sm:text-[50px] leading-[1] 900:text-[80px] 900:leading-[64px] font-[600] text-dark">
        Catalogue
      </h2>
      <div className="w-full flex flex-col gap-[10px] sm:gap-[20px] lg:hidden">
        <Link
          className="bg-gray group rounded-[12px] p-[10px] sm:p-[20px] md:p-[30px] w-full  flex flex-col gap-[45px] sm:gap-[120px] 900:gap-[170px] justify-between cursor-pointer relative max-h-[430px] hover:bg-[#0000005E]"
          to="/catalogue/pieces"
        >
          <h1 className="font-clash font-[600] text-[23px] leading-[21px] sm:text-[38px] sm:leading-[33px] 900:text-[48px] 900:leading-[43px] text-dark group-hover:text-white">
            Pièces <br /> {"d'occasion"}
          </h1>
          <div className="flex justify-end">
            <button className="w-[32px] sm:w-auto h-[32px] sm:h-auto sm:px-[24px] sm:py-[16px] bg-white group-hover:bg-orange group-hover:text-white center rounded-[8px]">
              <FaArrowRightLong />
            </button>
          </div>
          <img
            src="/pieces-occasion.png"
            alt="Pièces d'occasion automobile"
            title="Découvrez notre catalogue de pièces d'occasion"
            className="absolute left-0 bottom-0 max-w-[60%] max-h-[60%] scale-x-[-1]"
          />
        </Link>
        <div className="w-full grid grid-cols-2 gap-[10px] sm:gap-[20px]">
          <Link
            className="bg-gray group rounded-[12px] p-[10px] sm:p-[20px] md:p-[30px] w-full  flex flex-col gap-[45px] sm:gap-[120px] 900:gap-[170px] justify-between cursor-pointer relative max-h-[430px] hover:bg-[#0000005E]"
            to="/catalogue/jantes"
          >
            <h1 className="font-clash font-[600] text-[23px] leading-[21px] sm:text-[38px] sm:leading-[33px] 900:text-[48px] 900:leading-[43px] text-dark group-hover:text-white">
              Jantes <br /> {"d'occasion"}
            </h1>
            <div className="flex justify-end">
              <button className="w-[32px] sm:w-auto h-[32px] sm:h-auto sm:px-[24px] sm:py-[16px] bg-white group-hover:bg-orange group-hover:text-white center rounded-[8px]">
                <FaArrowRightLong />
              </button>
            </div>
            <img
              src="/jantes-occasion.png"
              alt="Jantes d'occasion pour voiture"
              title="Découvrez notre gamme de jantes d'occasion"
              className="absolute left-0 bottom-0 max-w-[60%] max-h-[60%] scale-x-[-1]"
            />
          </Link>
          <Link
            className="bg-gray group rounded-[12px] p-[10px] sm:p-[20px] md:p-[30px] w-full  flex flex-col gap-[45px] sm:gap-[120px] 900:gap-[170px] justify-between cursor-pointer relative max-h-[430px] hover:bg-[#0000005E]"
            to="/catalogue/pneus"
          >
            <h1 className="font-clash font-[600] text-[23px] leading-[21px] sm:text-[38px] sm:leading-[33px] 900:text-[48px] 900:leading-[43px] text-dark group-hover:text-white">
              Pneus <br /> {"d'occasion"}
            </h1>
            <div className="flex justify-end">
              <button className="w-[32px] sm:w-auto h-[32px] sm:h-auto sm:px-[24px] sm:py-[16px] bg-white group-hover:bg-orange group-hover:text-white center rounded-[8px]">
                <FaArrowRightLong />
              </button>
            </div>
            <img
              src="/pneus-occasion.png"
              alt="Pneus d'occasion toutes marques"
              title="Explorez notre sélection de pneus d'occasion"
              className="absolute left-0 bottom-0 max-w-[60%] max-h-[60%] scale-x-[-1]"
            />
          </Link>
          <Link
            to="/catalogue/vehicules-d-occasion"
            className="bg-gray rounded-[12px] p-[10px] sm:p-[20px] md:p-[30px] w-full  flex flex-col gap-[45px] sm:gap-[120px] 900:gap-[170px] group cursor-pointer justify-between relative max-h-[430px] hover:bg-[#0000005E]"
          >
            <h1 className="font-clash font-[600] text-[23px] leading-[21px] sm:text-[38px] sm:leading-[33px] 900:text-[48px] 900:leading-[43px] text-dark group-hover:text-white">
              Véhicules <br />
              d'occasion
            </h1>
            <div className="flex justify-end">
              <button className="w-[32px] sm:w-auto h-[32px] sm:h-auto sm:px-[24px] sm:py-[16px] bg-white group-hover:bg-orange group-hover:text-white center rounded-[8px]">
                <FaArrowRightLong />
              </button>
            </div>
            <img
              src="/vehicules-occasion.png"
              alt="Véhicules d'occasion à vendre"
              title="Explorez notre sélection de véhicules d'occasion"
              className="absolute left-0 bottom-0 max-w-[60%] max-h-[60%] scale-x-[-1]"
            />
          </Link>
          <Link
            to="/catalogue/vehicules-accidentes"
            className="bg-gray rounded-[12px] p-[10px] sm:p-[20px] md:p-[30px] flex flex-col justify-between gap-[45px] sm:gap-[120px] group 900:gap-[170px] cursor-pointer relative max-h-[430px] hover:bg-[#0000005E]"
          >
            <h1 className="font-clash font-[600] text-[23px] leading-[21px] sm:text-[38px] sm:leading-[33px] 900:text-[48px] 900:leading-[43px] text-dark group-hover:text-white">
              Véhicules <br />
              accidentés
            </h1>
            <div className="flex justify-end">
              <button className="w-[32px] sm:w-auto h-[32px] sm:h-auto sm:px-[24px] sm:py-[16px] bg-white group-hover:bg-orange group-hover:text-white center rounded-[8px]">
                <FaArrowRightLong />
              </button>
            </div>
            <img
              src="/vehicules-accidentes.png"
              alt="Véhicules accidentés disponibles"
              title="Consultez nos véhicules accidentés disponibles"
              className="absolute left-0 bottom-0 max-w-[65%] max-h-[60%] scale-x-[-1]"
            />
          </Link>
        </div>
      </div>

      <div className="w-full hidden lg:flex gap-[24px]">
        <Link
          to="/catalogue/pieces"
          className="bg-gray rounded-[12px] p-[10px] sm:p-[20px] md:p-[30px] basis-[calc((100%/3)*2-8px)] flex flex-col gap-[45px] sm:gap-[120px] 900:gap-[170px] group cursor-pointer justify-between relative h-[300px] hover:bg-[#0000005E]"
        >
          <strong className="font-clash font-[600] text-[23px] leading-[21px] sm:text-[38px] sm:leading-[33px] 900:text-[48px] 900:leading-[43px] text-dark group-hover:text-white">
            Pièces <br />
            d'occasion
          </strong>
          <div className="flex justify-end">
            <button className="w-[32px] sm:w-auto h-[32px] sm:h-auto sm:px-[24px] sm:py-[16px] bg-white group-hover:bg-orange group-hover:text-white rounded-[8px]">
              <FaArrowRightLong />
            </button>
          </div>
          <img
            src="/pieces-occasion.png"
            alt="Pièces d'occasion automobile"
            title="Découvrez notre catalogue de pièces d'occasion"
            className="absolute left-0 bottom-0 max-w-[60%] max-h-[60%] scale-x-[-1]"
          />
        </Link>
        <Link
          to="/catalogue/jantes"
          className="bg-gray rounded-[12px] p-[10px] sm:p-[20px] md:p-[30px] basis-[calc((100%/3)-16px)] flex flex-col gap-[45px] sm:gap-[120px] 900:gap-[170px] group cursor-pointer justify-between relative h-[300px] hover:bg-[#0000005E]"
        >
          <strong className="font-clash font-[600] text-[23px] leading-[21px] sm:text-[38px] sm:leading-[33px] 900:text-[48px] 900:leading-[43px] text-dark group-hover:text-white">
            Jantes <br />
            d'occasion
          </strong>
          <div className="flex justify-end">
            <button className="w-[32px] sm:w-auto h-[32px] sm:h-auto sm:px-[24px] sm:py-[16px] bg-white group-hover:bg-orange group-hover:text-white rounded-[8px]">
              <FaArrowRightLong />
            </button>
          </div>
          <img
            src="/jantes-occasion.png"
            alt="Jantes d'occasion pour voiture"
            title="Découvrez notre gamme de jantes d'occasion"
            className="absolute left-0 bottom-0 max-w-[60%] max-h-[60%] scale-x-[-1]"
          />
        </Link>
      </div>
      <div className="w-full hidden lg:flex gap-[24px]">
        <Link
          to="/catalogue/pneus"
          className="bg-gray rounded-[12px] p-[10px] sm:p-[20px] md:p-[30px] w-full flex flex-col gap-[45px] sm:gap-[120px] 900:gap-[170px] group cursor-pointer justify-between relative h-[300px] hover:bg-[#0000005E]"
        >
          <strong className="font-clash font-[600] text-[23px] leading-[21px] sm:text-[38px] sm:leading-[33px] 900:text-[48px] 900:leading-[43px] text-dark group-hover:text-white">
            Pneus <br />
            d'occasion
          </strong>
          <div className="flex justify-end">
            <button className="w-[32px] sm:w-auto h-[32px] sm:h-auto sm:px-[24px] sm:py-[16px] bg-white group-hover:bg-orange group-hover:text-white rounded-[8px]">
              <FaArrowRightLong />
            </button>
          </div>
          <img
            src="/pneus-occasion.png"
            alt="Pneus d'occasion toutes marques"
            title="Explorez notre sélection de pneus d'occasion"
            className="absolute left-0 bottom-0 max-w-[60%] max-h-[60%] scale-x-[-1]"
          />
        </Link>
        <Link
          to="/catalogue/vehicules-d-occasion"
          className="bg-gray rounded-[12px] p-[10px] sm:p-[20px] md:p-[30px] w-full flex flex-col gap-[45px] sm:gap-[120px] 900:gap-[170px] group cursor-pointer justify-between relative h-[300px] hover:bg-[#0000005E]"
        >
          <strong className="font-clash font-[600] text-[23px] leading-[21px] sm:text-[38px] sm:leading-[33px] 900:text-[48px] 900:leading-[43px] text-dark group-hover:text-white">
            Véhicules <br />
            d'occasion
          </strong>
          <div className="flex justify-end">
            <button className="w-[32px] sm:w-auto h-[32px] sm:h-auto sm:px-[24px] sm:py-[16px] bg-white group-hover:bg-orange group-hover:text-white rounded-[8px]">
              <FaArrowRightLong />
            </button>
          </div>
          <img
            src="/vehicules-occasion.png"
            alt="Véhicules d'occasion à vendre"
            title="Explorez notre sélection de véhicules d'occasion"
            className="absolute left-0 bottom-0 max-w-[60%] max-h-[60%] scale-x-[-1]"
          />
        </Link>
        <Link
          to="/catalogue/vehicules-accidentes"
          className="bg-gray rounded-[12px] p-[10px] sm:p-[20px] md:p-[30px] w-full flex flex-col gap-[45px] sm:gap-[120px] 900:gap-[170px] group cursor-pointer justify-between relative h-[300px] hover:bg-[#0000005E]"
        >
          <strong className="font-clash font-[600] text-[23px] leading-[21px] sm:text-[38px] sm:leading-[33px] 900:text-[48px] 900:leading-[43px] text-dark group-hover:text-white">
            Véhicules <br />
            accidentés
          </strong>
          <div className="flex justify-end">
            <button className="w-[32px] sm:w-auto h-[32px] sm:h-auto sm:px-[24px] sm:py-[16px] bg-white group-hover:bg-orange group-hover:text-white rounded-[8px]">
              <FaArrowRightLong />
            </button>
          </div>
          <img
            src="/vehicules-accidentes.png"
            alt="Véhicules accidentés disponibles"
            title="Consultez nos véhicules accidentés disponibles"
            className="absolute left-0 bottom-0 max-w-[65%] max-h-[60%] scale-x-[-1]"
          />
        </Link>
      </div>
    </div>
  );
};

export default Catalogue;
